





import Vue from "vue";

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    iconSize: {
      type: Number,
      default: 24,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    onClick: Function,
  },

  computed: {
    style() {
      return {
        width: `${this.iconSize}px`,
        height: `${this.iconSize}px`,
      };
    },
  },
});

interface Props {
  iconSize: number;
  isWhite: boolean;
  onClick: () => void;
}
